module.exports = __webpack_public_path__ + "static/media/appweb.64c9d808.webp";